// react
import React from "react"
// material-ui
import { Card, CardActions, CardHeader, CardText } from "material-ui/Card"
import FlatButton from "material-ui/FlatButton"
import MenuItem from "material-ui/MenuItem"
import MUISelectField from "material-ui/SelectField"
// app
import AutoComplete from "containers/AutoComplete"
import SelectField, { Style } from "containers/SelectField"
import TextField from "components/common/TextField"


const initialState = {
    lastname: "",
    rating: "",
    homebase: "",
    citizenship: "",
    hours: "",
    rank: "",
    language: "",
    visa: "",
    jobstatus: "",
    company: "",
    lookingfor: "",
    type: ""
}

class SearchForm extends React.Component {
    constructor(props) {
        super()
        this.state = initialState

        this.setLastname = lastname => this.setState({ lastname })
        this.setRating = rating => this.setState({ rating })
        this.setHomebase = homebase => this.setState({ homebase })
        this.setType = type => this.setState({ type })
        this.setCitizenship = citizenship => this.setState({ citizenship })
        this.setHours = hours => this.setState({ hours })
        this.setRank = rank => this.setState({ rank })
        this.setLanguage = language => this.setState({ language })
        this.setVisa = visa => this.setState({ visa })
        this.setJobStatus = jobstatus => this.setState({ jobstatus })
        this.setCompany = company => this.setState({ company })
        this.onLookingForChange = (e, key, value) => this.setState({ lookingfor: value })

        this.search = this.search.bind(this)
        this.onKeyDown = this.onKeyDown.bind(this)
    }

    onKeyDown(e) {
        if (e.keyCode !== 13) return
        if (this.state === initialState) return
        this.search()
    }

    search() {
        this.props.onSearch(this.state)
    }

    render() {
        return (
            <Card>
                <CardHeader
                    title="Search"
                    style={{ paddingBottom: 0 }}
                />
                <CardText className="clearfix">
                    <div className="float-left">
                        <TextField
                            autoFocus={ true }
                            label="Lastname"
                            onChange={ this.setLastname }
                            onKeyDown={ this.onKeyDown }
                        />
                        <br />
                        <TextField
                            label="Homebase"
                            onChange={ this.setHomebase }
                            onKeyDown={ this.onKeyDown }
                        />
                        <br />
                        <TextField
                            label="Total Flight Hours"
                            onChange={ this.setHours }
                            onKeyDown={ this.onKeyDown }
                            type="number"
                        />
                        <br />
                        <AutoComplete
                            table="language"
                            label="Language"
                            onChange={ this.setLanguage }
                        />
                        <br />
                        <SelectField
                            table="jobstatus"
                            label="Job Status"
                            style={ Style.ValueOnly }
                            onChange={ this.setJobStatus }
                        />
                        <MUISelectField
                            floatingLabelText="Looking For"
                            onChange={ this.onLookingForChange }
                            fullWidth={ true }
                            value={ this.state.lookingfor }
                        >
                            <MenuItem
                                value="freelance"
                                key="freelance"
                                primaryText="Freelance Contracts" />
                            <MenuItem
                                value="permanent"
                                key="permanent"
                                primaryText="Permanent Contracts" />
                            <MenuItem
                                value="notlooking"
                                key="notlooking"
                                primaryText="Currently Not Looking" />
                        </MUISelectField>
                    </div>
                    <div className="float-right">
                        <AutoComplete
                            table="rating"
                            extensible={ true }
                            label="Rating"
                            maxLength={ 50 }
                            onChange={ this.setRating }
                        />
                        <br />
                        <SelectField
                            table="type"
                            label="Profile Type"
                            style={ Style.ValueOnly }
                            onChange={ this.setType }
                        />
                        <br />
                        <AutoComplete
                            table="country"
                            extensible={ true }
                            label="Citizenship"
                            onChange={ this.setCitizenship }
                        />
                        <br />
                        <SelectField
                            table="rank"
                            label="Rank"
                            style={ Style.ValueOnly }
                            onChange={ this.setRank }
                        />
                        <br />
                        <SelectField
                            table="visa"
                            label="Visa"
                            style={ Style.ValueOnly }
                            onChange={ this.setVisa }
                        />
                        <br />
                        <TextField
                            label="Company"
                            onChange={ this.setCompany }
                            onKeyDown={ this.onKeyDown }
                        />
                    </div>
                </CardText>
                <CardActions>
                    <FlatButton
                        label="Search"
                        primary={ true }
                        onClick={ this.search }
                        disabled={ this.state === initialState }
                    />
                </CardActions>
            </Card>
        )
    }
}

export default SearchForm


/** WEBPACK FOOTER **
 ** ./src/components/search/Form/search-form.js
 **/